import React from 'react';
import { ShowButton, Datagrid, DateField, TextField, Filter, SelectInput, TextInput } from 'react-admin';
import TList from 'cw-core-admin-ui/src/components/wrapper/TList';
import { LinkField } from 'cw-core-admin-ui/src/components/fields';
import { shopConfigurationStatusForSelection } from './ShopConfigurationConstants';

const ShopConfigurationFilter = (props) => (
	<Filter {...props}>
		<TextInput resettable source="walletId" label="resources.shopConfigurations.filter.walletId" />
		<TextInput resettable source="walletId" label="resources.shopConfigurations.filter.walletAccountId" />
		<SelectInput resettable source="shopConfigurationStatus" label="resources.shopConfigurations.filter.shopConfigurationStatus" choices={shopConfigurationStatusForSelection} />
	</Filter>
);

export default ({ shopConfigurationStatusForSelection, ...props }) => (
	<TList exporter={false} {...props} filters={<ShopConfigurationFilter />}>
		<Datagrid>
			<ShowButton />
			<TextField source="shopConfigurationId" />
			<LinkField source="walletAccountId" type="WalletAccount" />
			<DateField source="creationDateTime" showTime />
			<TextField source="shopConfigurationStatus" />
			<TextField source="name" />
			<TextField source="currencyCode" />
			<TextField source="shopCategoryCode" />
		</Datagrid>
	</TList>
);
